module.exports = __webpack_public_path__ + "img/06.4804b1e4.jpg";